import { WorkOrderTableRow } from "./types";

export const MOCK_WORK_ORDERS: WorkOrderTableRow[] = [
  {
    id: 1,
    workOrderId: "WO-5501",
    status: "IN_PRODUCTION",
    customerName: "TAVGA_TRANSPORT",
    vehicle: "REFRIGERATED_TRAILER_12M",
    currentStage: "PAINT",
    progress: 65,
    priority: "HIGH",
  },
  {
    id: 2,
    workOrderId: "WO-5502",
    status: "IN_PRODUCTION",
    customerName: "SHLOMO_LOGISTICS",
    vehicle: "CLOSED_BOX_TRUCK",
    currentStage: "METALWORK",
    progress: 15,
    priority: "MEDIUM",
  },
  {
    id: 3,
    workOrderId: "WO-5503",
    status: "IN_PRODUCTION",
    customerName: "GAL_COLD_CHAIN",
    vehicle: "REFRIGERATED_SEMI",
    currentStage: "QUALITY_CONTROL_STAGE",
    progress: 90,
    priority: "NORMAL",
  },
];
